export const ROUTES = {
  index: '/:pharmacyId',
  auth: {
    login: '/:pharmacyId/login',
    loginCip: '/login/cip',
    reset: '/:pharmacyId/reset',
    resetToken: '/:pharmacyId/reset/:token',
    definePassword: '/:pharmacyId/define-password',
  },
  orders: {
    root: '/:pharmacyId/commandes',
    detail: '/:pharmacyId/commandes/commande/:id',
  },
  catalog: {
    root: '/:pharmacyId/catalogue',
    newProduct: '/:pharmacyId/catalogue/nouveau-produit',
    generateQRCode: '/:pharmacyId/catalogue/nouveau-qr-code',
  },
  promotions: {
    promotionsCnc: '/:pharmacyId/promotions',
    promotionCnc: '/:pharmacyId/promotion',
    promotionsCode: '/:pharmacyId/promotion-codes',
    promotionsProducts: '/:pharmacyId/promotions-produits',
    promotionsSnC: '/:pharmacyId/promotions-essentiel',
  },
  meetings: {
    root: '/:pharmacyId/calendrier',
    slots: '/:pharmacyId/calendrier/creneaux',
    print: '/:pharmacyId/calendrier/imprimer',
  },
  waitingList: {
    root: '/:pharmacyId/listes-attente',
    details: '/:pharmacyId/listes-attente/editer/:waitingId',
  },
  forms: {
    root: '/:pharmacyId/formulaires',
    detail: '/:pharmacyId/formulaire/:formType',
    edit: '/:pharmacyId/formulaire-edition',
  },
  content: {
    blog: '/:pharmacyId/contenu/articles',
    articleEdit: '/:pharmacyId/contenu/articles/edition',
    events: '/:pharmacyId/contenu/evenements',
    pharmacistWord: '/:pharmacyId/contenu/mot-du-pharmacien',
    communicationMedia: '/:pharmacyId/contenu/supports-communication',
  },
  patient: {
    add: '/:pharmacyId/patient/new',
    search: '/:pharmacyId/patient-search',
  },
  delivery: {
    locker: '/:pharmacyId/livraison/casier/prix-fixe',
    uber: '/:pharmacyId/livraison/UberDeliveryService/prix-fixe',
    deliveryService: '/:pharmacyId/livraison/:serviceName/prix-fixe',
    addressesManagement: '/:pharmacyId/livraison/gestion-adresses',
  },
  jobs: {
    root: '/:pharmacyId/carrieres/offres',
    jobEdit: '/:pharmacyId/carrieres/offres/edition',
    jobDuplicate: '/:pharmacyId/carrieres/offres/dupliquer',
  },
  dashboard: '/:pharmacyId/tableau-de-bord',
  profile: '/:pharmacyId/profile',
  cncConfiguration: '/:pharmacyId/services-de-livraison',
  synchronization: '/:pharmacyId/synchronisation',
  communication: '/:pharmacyId/communication',
  messaging: '/:pharmacyId/messagerie',
  onDuty: '/:pharmacyId/pharmacies-gardes',
  forum: '/:pharmacyId/forum',
  campaigns: '/:pharmacyId/campagnes',
  accessConfiguration: '/:pharmacyId/access',
  myPharmacy: '/:pharmacyId/ma-pharmacie',
  team: '/:pharmacyId/equipe',
  linings: '/:pharmacyId/gammes',
  services: '/:pharmacyId/services',
  specialities: '/:pharmacyId/specialites',
  images: '/:pharmacyId/images',
  videos: '/:pharmacyId/videos',
  tips: '/:pharmacyId/informations-utiles',
  sections: '/:pharmacyId/sections',
  sectionCreate: '/:pharmacyId/sections/creation',
  sectionEdit: '/:pharmacyId/sections/edition',
  notices: '/:pharmacyId/faq',
  configure: '/:pharmacyId/configure',
  diag: '/:pharmacyId/diag',
  integrations: {
    instagramOAuthSuccess: '/:pharmacyId/integrations/oauth/instagram/success',
    instagramOAuthError: '/:pharmacyId/integrations/oauth/instagram/error',
  },
} as const;
